export const topregiony = {
  "regiony": {
    "@ile": "3",
    "item": [
      {
        "nazwa": "Pekin",
        "lokalizacje": "CNL000014",
        "url": "www.chiny.com.pl/wakacje/wycieczki-pekin.xml",
        "cena": "4629"
      },
      {
        "nazwa": "Szanghaj",
        "lokalizacje": "CNL000025",
        "url": "www.chiny.com.pl/wakacje/wycieczki-szanghaj.xml",
        "cena": "4799"
      },
      {
        "nazwa": "Hong Kong",
        "lokalizacje": "CNL000032",
        "url": "www.chiny.com.pl/wakacje/wycieczki-hong-kong.xml",
        "cena": "6949"
      }
    ]
  }
}
